export const PageContainer = ({ children }: PageContainer.Props) => (
  <div className="grow flex flex-col animate-in fade-in duration-300">{children}</div>
)

namespace PageContainer {
  export type Props = {
    children: React.ReactNode
  }
}
